export function groupFields(fields) {
    const groupedFields = []; //Group in an array to get the same ordering as in the JQuery version
    fields
        .filter((x) => x.onProdForm == 1)
        .forEach((field) => {
            const groupName = field.prodFormGroup;
            let groupIndex = groupedFields.findIndex((group) =>
                group.find((x) => x.prodFormGroup == groupName)
            );
            if (groupIndex == -1) {
                groupIndex = groupedFields.length;
                groupedFields.push([]);
            }
            const group = groupedFields[groupIndex];
            group.push(field);
            groupedFields[groupIndex] = group;
        });
    return groupedFields;
}
